
export const PROFILES = {
   // ev000 EdebêLab
  ADMIN: 'ev000',
  GESTOR: 'ev004',
  COORDENADOR: 'ev005',
  PROFESSOR: 'ev002',
  ALUNO: 'ev001',
}

export const getUserProfile = (roles) => {
  if (roles) {
    for (var p in PROFILES) {
      var profile = PROFILES[p]
      if (roles.indexOf(profile) >= 0) {
        return profile
      }
    }
  }
}

export default {

  isUserCoordenador(userContainer) {
    // ev004 Gestão
    // ev005 Coordenador
    const profile = ['ev004', 'ev005'];
    console.log('userContainer.state.profile.decodedToken', userContainer.state.profile.decodedToken)
    if (!userContainer.state.profile || !userContainer.state.profile.decodedToken || !userContainer.state.profile.decodedToken.role) {
      return false;
    }
    var result = false;
    for (var i = 0; i < profile.length; i++) {
      if (userContainer.state.profile.decodedToken.role.indexOf(profile[i]) >= 0) {
        result = true;
      }
    }

    return result;
  },

  isUserProfessor(userContainer) {
    // ev002 Professor
    const profile = ['ev002'];
    console.log('userContainer.state.profile.decodedToken', userContainer.state.profile.decodedToken)
    if (!userContainer.state.profile || !userContainer.state.profile.decodedToken || !userContainer.state.profile.decodedToken.role) {
      return false;
    }
    var result = false;
    for (var i = 0; i < profile.length; i++) {
      if (userContainer.state.profile.decodedToken.role.indexOf(profile[i]) >= 0) {
        result = true;
      }
    }

    return result;
  }, 

  isUserAluno(userContainer) {
    // ev001 Aluno
    const profile = ['ev001'];
    console.log('userContainer.state.profile.decodedToken', userContainer.state.profile.decodedToken)
    if (!userContainer.state.profile || !userContainer.state.profile.decodedToken || !userContainer.state.profile.decodedToken.role) {
      return false;
    }
    var result = false;
    for (var i = 0; i < profile.length; i++) {
      if (userContainer.state.profile.decodedToken.role.indexOf(profile[i]) >= 0) {
        result = true;
      }
    }

    return result;
  }, 

  isUserAdmin(userContainer) {
    // ev000 EdebêLab
    const profile = 'ev000';
    if (!userContainer.state.profile || !userContainer.state.profile.decodedToken || !userContainer.state.profile.decodedToken.role) {
      return false;
    }

    return (userContainer.state.profile.decodedToken.role.indexOf(profile) >= 0)
  }

}